import { SxProps, Theme } from '@mui/material';

export const headerSpecs: SxProps<Theme> = () => ({
	width: '100%',
	'& .MuiAccordionDetails-root': {
		// padding: '0px',
		'& .MuiGrid-item': {
			paddingTop: '0px',
		},
		'& .MuiGrid-container': {
			rowGap: '8px',
		},
	},
});
export const accordionSummary: SxProps<Theme> = () => ({
	p: { sm: '10px', md: '0' },
	'& .MuiAccordionSummary-content': {
		margin: 0,
	},
	'&.MuiAccordionSummary-gutters': {
		paddingLeft: 0,
		paddingRight: 0,
	},
});
export const contentBoxTemplate: SxProps<Theme> = {
	height: '100%',
	display: 'flex',
	alignItems: 'center',
};

export const attributeNameBox: SxProps<Theme> = {
	width: '50%',
	padding: '10px',
};

export const attributeValueBox: SxProps<Theme> = {
	width: '50%',
	padding: '10px',
};

export const constantGridProps = {
	spacing: 1.25, // 10px spacing
};

export const constantGridItemProps = {
	xs: 12,
	md: 6,
};
